var _circle, _rect, _path, _rect2, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23.8326,
    r: 23,
    fill: "#F3F4F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8242,
    y: 11.656,
    width: 24.3529,
    height: 27.0588,
    rx: 1.36842,
    fill: "#CCD0D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8242 13.0244C10.8242 12.2687 11.4369 11.656 12.1926 11.656H33.8087C34.5645 11.656 35.1772 12.2687 35.1772 13.0244V35.9935C35.1772 36.7492 34.5645 37.3619 33.8087 37.3619H12.1926C11.4369 37.3619 10.8242 36.7492 10.8242 35.9935V13.0244Z",
    fill: "#E6E7E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8242,
    y: 13.0089,
    width: 24.3529,
    height: 24.3529,
    rx: 1.36842,
    fill: "#3F6FD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8242 25.1853H35.1772V35.9934C35.1772 36.7491 34.5645 37.3618 33.8087 37.3618H12.1926C11.4369 37.3618 10.8242 36.7491 10.8242 35.9934V25.1853Z",
    fill: "#4B8BF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8828 10.3031C14.8828 9.55593 15.4885 8.9502 16.2358 8.9502C16.983 8.9502 17.5887 9.55593 17.5887 10.3031V11.6561H14.8828V10.3031Z",
    fill: "#CCD0D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4121 10.3031C28.4121 9.55593 29.0178 8.9502 29.7651 8.9502C30.5123 8.9502 31.118 9.55593 31.118 10.3031V11.6561H28.4121V10.3031Z",
    fill: "#CCD0D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7634 25.8011H20.6179C21.5603 25.8011 22.1413 26.2504 22.1364 27.056C22.1315 27.7396 21.5554 28.2279 20.696 28.2279C19.8122 28.2279 19.2116 27.7836 19.1579 27.0951H18.1081C18.1765 28.306 19.1872 29.141 20.696 29.141C22.1657 29.141 23.2497 28.2963 23.2497 27.056C23.2497 26.0697 22.5564 25.4398 21.5212 25.347V25.3226C22.3855 25.142 23.0056 24.5511 23.0056 23.6674C23.0056 22.6176 22.1218 21.8314 20.6862 21.8314C19.3093 21.8314 18.3474 22.6176 18.2595 23.848H19.2849C19.3386 23.1449 19.905 22.7299 20.6862 22.7299C21.5163 22.7299 21.9411 23.1595 21.9411 23.8187C21.9411 24.4779 21.3942 24.9515 20.5886 24.9515H19.7634V25.8011ZM26.072 29.0092H27.1413V21.9633H26.0622L24.2067 23.2816V24.3168L26.0476 23.0472H26.072V29.0092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.3d88460bd17df2e9996f333684f59566.svg";
export { ForwardRef as ReactComponent };